import classNames from "classnames";
import classes from "./CMSColumnContainer.module.less";
import type { CMSColumnDTO } from "~/CMSComponents/dto";
import { useNumericScreenSize } from "~/common/hooks/useNumericScreenSize";
import { renderCMSComponent } from "~/CMSComponents/componentFactory";

interface Props extends Omit<CMSColumnDTO, "type"> {
  className?: string;
}

export const CMSColumn = (props: Props) => {
  const pageSize = useNumericScreenSize();
  const width =
    props.widths
      // Take widths from all breakpoints up to current one as candidates
      .slice(0, pageSize)
      // Filter out nulls
      .filter(Boolean)
      // Take the last one, meaning the one that is closest to the current breakpoint
      .reverse()[0] ?? 100;
  return (
    <div className={classNames(classes.columnOuter, props.className)} style={{ width: `${width}%` }}>
      <div className={classes.columnInner}>
        {props.children.map((child, index) => {
          return renderCMSComponent(child, undefined, index);
        })}
      </div>
    </div>
  );
};
